module.exports = __webpack_public_path__ + "assets/img/企业简介_06.cddb3138.jpg";